import React from 'react';
import './pagination.css';

export default function Pagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  const handleClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  return (
    <div className="pagination-div">
      <button
        className="pagination-side-buttons"
        disabled={currentPage === 1}
        onClick={() => handleClick(currentPage - 1)}
      >
        « Previous
      </button>

      {[...Array(totalPages)].map((_, index) => {
        const page = index + 1;
        return (
          <button
            key={page}
            className={`pagination-page-btn ${currentPage === page ? 'active' : ''}`}
            onClick={() => handleClick(page)}
          >
            {page}
          </button>
        );
      })}

      <button
        className="pagination-side-buttons"
        disabled={currentPage === totalPages}
        onClick={() => handleClick(currentPage + 1)}
      >
        Next »
      </button>
    </div>
  );
}
